<!--
  @USE AS:
  import InputWrap from '@/components/base/InputWrap'

  components: { InputWrap }

  <InputWrap
    placeholder="test"
    v-model="data"
  />
-->

<template>
  <div class="input-wrap">
    <input
      :type="type"
      v-bind="$attrs"
      :value="value"
      :style="{
        'text-align': align
      }"
      v-on="$listeners"
      @input="$emit('update', $event.target.value)"
      @focus="handleEmptyOnFocus('focus')"
      @blur="handleEmptyOnFocus('blur')"
    >
  </div>
</template>

<script>
export default {
  name: 'InputWrap',

  inheritAttrs: false,

  model: {
    prop: 'value',
    event: 'update'
  },

  props: {
    value: {
      type: [String, Number],
      default: null
    },

    type: {
      type: [String],
      default: 'text'
    },

    emptyOnFocus: {
      type: Boolean,
      default: false
    },

    align: {
      type: String,
      default: 'left'
    }
  },

  data () {
    return {
      oldValue: null
    }
  },

  async mounted () {
    await this.$nextTick()

    if (this.oldValue === null) {
      this.oldValue = this.value
    }
  },

  methods: {
    handleEmptyOnFocus (type) {
      if (!this.emptyOnFocus) {
        return
      }

      if (type === 'focus') {
        this.oldValue = this.value
        this.$emit('update', '')
      } else if (type === 'blur') {
        if (this.value !== this.oldValue && this.value !== '') {
          this.oldValue = this.value
        }

        this.$emit('update', this.oldValue)
      }
    }
  }
}
</script>
